import { Button, Group, Modal, Text } from "@mantine/core";

type InterestActionConfirmModalProps = {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmLabel?: string;
  confirmColor?: string;
  isLoading?: boolean;
};

export default function InterestActionConfirmModal({
  opened,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel = "Confirm",
  confirmColor = "primary",
  isLoading = false,
}: InterestActionConfirmModalProps) {
  return (
    <Modal opened={opened} onClose={onClose} centered title={title} size="sm">
      <Text size="sm" c="slate.7" mb="lg">
        {message}
      </Text>
      <Group justify="flex-end" gap="sm">
        <Button variant="default" onClick={onClose} disabled={isLoading}>
          Cancel
        </Button>
        <Button color={confirmColor} onClick={onConfirm} loading={isLoading}>
          {confirmLabel}
        </Button>
      </Group>
    </Modal>
  );
}
